import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { SmsCodeFormProps } from "../model";
import { Desktop, Mobile } from "./components";

export const SmsCodeForm = (props: SmsCodeFormProps) => {
  return (
    <ResponsiveBlockSwitcher desktop={<Desktop {...props} />} mobile={<Mobile {...props} />} />
  );
};
